import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IntegrationService } from 'src/app/services/integration.service';
import { PBXService } from 'src/app/services/pbx.service';
import { environment } from 'src/environments/environment';
import { IPbxUser } from 'voxloud-types/dist/models';
import { INTEGRATION_STATUS } from 'voxloud-types/dist/models/integrations';

import { ChatService } from '../../services/chat.service';
import { SessionService } from '../shell/session.service';
import { SubscriptionService } from '../shell/subscription.service';

const PAGE_SIZE = 1;

@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss'],
})
export class OptionsComponent implements OnInit {
  public user: IPbxUser | null = null;
  public currency_code: string | null = null;
  public session = this.currentSession.current;
  public chatProvider: 'voxloud' | 'romulus' | null = null;

  constructor(
    private currentSession: SessionService,
    private sanitizer: DomSanitizer,
    private chat: ChatService,
    private subscriptionService: SubscriptionService,
    private pbxService: PBXService,
    private integrationService: IntegrationService,
    private router: Router
  ) {}

  ngOnInit() {
    forkJoin({
      subscription: this.subscriptionService.getSubscription(),
      users: this.pbxService.getUsers(this.session.pbxId),
      pbx: this.pbxService.getPbx(),
    }).subscribe({
      next: ({ subscription, users, pbx }) => {
        this.currency_code = subscription.currency_code ?? null;
        this.user = users.find((user) => user.email === this.session.email) || null;
        this.pbxService.setPbx(pbx);

        const hasVoxloud = (subscription.addons || []).some((a) => a.id && a.id.includes('chat_platform'));
        if (hasVoxloud) {
          this.chatProvider = 'voxloud';
        } else {
          this.loadRomulusIntegration();
        }
      },
      error: (err) => {
        console.error('Error loading data:', err);
        this.user = null;
      },
    });
  }

  public openChat(): void {
    this.chat.show();
  }

  public openInbox(): void {
    if (!this.chatProvider) return;
    this.router.navigate(['/inbox'], { state: { provider: this.chatProvider } });
  }

  public goToControlPanel(): void {
    window.open(this.session.controlPanelUrl, '_blank');
  }

  public sanitize(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(`${environment.CALL_PREFIX}${url}?dialAction=autoCall`);
  }

  public get isChatActive(): boolean {
    return this.chatProvider !== null;
  }

  private loadRomulusIntegration(): void {
    this.integrationService
      .getIntegrationsByFilter(0, PAGE_SIZE, {
        company_id: this.session.companyId,
        platform_name: 'ROMULUS',
        enabled: true,
        status: INTEGRATION_STATUS.ACTIVE,
      })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          if (err.status === 404) return of(null);
          console.error('Error loading Romulus integration:', err);

          return throwError(err);
        })
      )
      .subscribe({
        next: (response) => {
          if ((response?.content?.length ?? 0) > 0) {
            this.chatProvider = 'romulus';
          }
        },
      });
  }
}
